import { takeLatest, call, select, put } from 'redux-saga/effects';

import { createStandaloneToast, theme } from '@frontend/components';

import supplierTableService from 'services/supplierTableService';

import history from 'utils/browserHistory';

import {
  actionModal,
  deleteTable,
  detailsPage,
  renameTable,
  types,
  updateTable,
} from './actions';
import { getTableId } from './reducer';

export default function* root() {
  yield takeLatest(types.RENAME_CUSTOM_TABLE_REQUEST, watchRenameTable);
  yield takeLatest(types.UPDATE_CUSTOM_TABLE_REQUEST, watchUpdateTable);
  yield takeLatest(types.DELETE_CUSTOM_TABLE_REQUEST, watchDeleteTable);
}

const { toast } = createStandaloneToast({ theme });

const getTableData = (rawTable) => {
  const formattedColumns = rawTable.columns
    .filter((name) => name !== 'row_number')
    .map((name) => {
      return {
        title: name,
        dataIndex: name,
        key: name,
      };
    });
  const formattedRows = rawTable.rows.map((row) => {
    const rowObject = {};
    row.forEach((entry) => {
      rowObject[entry.key] = entry.value;
    });
    return {
      ...rowObject,
      key: rowObject.row_number,
    };
  });
  return {
    columns: formattedColumns,
    rows: formattedRows,
  };
};

export function* initSupplierTablesDetailsPage({ match }) {
  const tableId = match.params.customTableId;
  const table = yield call(supplierTableService.get, tableId);
  const tableData = getTableData(table);
  yield put(detailsPage.init({ table }));
  yield put(detailsPage.receiveTableData({ tableData }));
}

function* watchRenameTable(action) {
  const { payload } = action;
  const { name } = payload;
  const tableId = yield select(getTableId);

  try {
    const response = yield call(supplierTableService.update, tableId, { name });
    yield put(renameTable.success({ table: response }));
    yield put(actionModal.close());
  } catch (error) {
    yield put(renameTable.error(error));
  }
}

function* watchUpdateTable(action) {
  const { payload } = action;
  const tableId = yield select(getTableId);

  try {
    const response = yield call(supplierTableService.update, tableId, payload);
    const tableData = getTableData(response);
    yield put(detailsPage.receiveTableData({ tableData }));
    yield put(updateTable.success({ table: response }));
    yield put(actionModal.close());
  } catch (error) {
    yield put(updateTable.error(error));
  }
}

function* watchDeleteTable() {
  const tableId = yield select(getTableId);

  try {
    yield call(supplierTableService.delete, tableId);
    yield put(deleteTable.success());
    yield put(actionModal.close());
    history.push('/processes/tables');
    yield call(toast, {
      title: 'Success',
      status: 'success',
      description: 'Custom table was successfully deleted.',
    });
  } catch (error) {
    yield put(deleteTable.error(error));
  }
}
